import { Bell, CheckCheck } from "lucide-react";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { Notificacao } from "shared/components/notificacao/Notificacao";
import { useNotificacoes } from "shared/hooks/useNotificacoes";
import styles from "./TodasNotificacoes.module.scss";

export const TodasNotificacoes = () => {
  const { marcarTodasComoLidas } = useNotificacoes();
  return (
    <PageContainer title="Minhas Notificações" icon={<Bell size={18} />} contentClassName={styles.whiteContent} showDesktopSearch={false}>
      <div className={styles.page}>
        <div className={styles.actions}>
          <button type="button" className={styles.btnLidas} onClick={marcarTodasComoLidas}>
            <CheckCheck size={18} />
            <span>Marcar todas como lidas</span>
          </button>
        </div>
        <Notificacao modo="pagina" />
      </div>
    </PageContainer>
  );
};
